import { useMutation } from '@apollo/client';
import {
  LogClickEvent,
  // eslint-disable-next-line camelcase
  LogClickEvent_logClickEvent_LogClickEventPayload,
  LogClickEventVariables,
} from '@/__generated__/LogClickEvent';
import { LOG_CLICK_EVENT } from '@/components/request/GQL';
import { SKIP_AUTH_CONTEXT_KEY } from '@/constants';

export const useClickEventLogger = (): ((memberUuid: string) => Promise<undefined | number>) => {
  const [fireClickEvent] = useMutation<LogClickEvent, LogClickEventVariables>(LOG_CLICK_EVENT, {
    context: { [SKIP_AUTH_CONTEXT_KEY]: true },
  });
  return async (memberUuid: string) => {
    const response = await fireClickEvent({
      variables: { input: { memberUuid } },
      context: { [SKIP_AUTH_CONTEXT_KEY]: true },
    });

    if (response.errors || response.data?.logClickEvent.__typename === 'LogClickEventError') {
      return undefined;
    }
    if (response.data?.logClickEvent.__typename === 'LogClickEventPayload') {
      const logClickPayload = response!.data! // eslint-disable-next-line camelcase
        .logClickEvent as LogClickEvent_logClickEvent_LogClickEventPayload;

      return logClickPayload.status;
    }
    return undefined;
  };
};
